export default {
  apiUrl: '/api/'
};



// WEBPACK FOOTER //
// ./config.client.js